import { useRef } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'

import { breakpoints, colors } from '@/styles'
import { Button } from '@/components/button-new'
import { useLandlordsPageLandlordTestimonials } from '@/components/testimonials'

import TestimonialCard from './testimonial-card'
import { ReactComponent as ButtonLeftIcon } from './button-left.svg'
import { ReactComponent as ButtonRightIcon } from './button-right.svg'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const StyledButton = styled(Button)`
  display: block;
  position: absolute;
  bottom: 0;
  padding: 0;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    display: none !important;
  }
`

const Wrapper = styled.div`
  padding: 16px 0;

  .slick-slider .slick-next,
  .slick-slider .slick-prev {
    height: 35px;
    transform: translate(0, -50%);
  }

  .slick-slider .slick-next:before,
  .slick-slider .slick-prev:before {
    color: rgba(0, 0, 0, 0.6);
    display: none;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide {
    margin: 0 16px;
  }

  .slick-dots {
    bottom: -25px;
  }

  .slick-dots li {
    width: 16px;
    height: 16px;

    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      width: 12px;
      height: 12px;
    }
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;

    display: block;

    width: 16px;
    height: 16px;
    padding: 5px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;

    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      width: 12px;
      height: 12px;
    }
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 6px;
    line-height: 16px;

    position: absolute;
    top: 0;
    left: 0;

    width: 16px;
    height: 16px;
    border-radius: 50%;

    content: '';
    text-align: center;
    background-color: ${colors.grey88};

    color: ${colors.grey88};
    border: 1px solid ${colors.grey88};
    opacity: 1 !important;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      line-height: 12px;

      width: 12px;
      height: 12px;
    }
  }
  .slick-dots li.slick-active button:before {
    opacity: 1 !important;
    background-color: #fafafa;
    color: #fafafa;
  }
`

const TestimonialScroller = () => {
  const slider = useRef<Slider>(null)
  const landlordTestimonials = useLandlordsPageLandlordTestimonials()

  return (
    <Wrapper>
      <Slider
        infinite
        slidesToShow={3}
        slidesToScroll={3}
        prevArrow={
          <StyledButton
            theme="text"
            size="unset"
            id="landlord-testimonial-back-click"
            aria-label="Previous"
            onClick={() => slider?.current?.slickPrev()}
          >
            <ButtonLeftIcon />
          </StyledButton>
        }
        nextArrow={
          <StyledButton
            theme="text"
            size="unset"
            id="landlord-testimonial-fwd-click"
            aria-label="Next"
            onClick={() => slider?.current?.slickNext()}
          >
            <ButtonRightIcon />
          </StyledButton>
        }
        dots
        responsive={[
          {
            breakpoint: 1150,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
        ref={slider}
      >
        {landlordTestimonials.map(testimonial => {
          return (
            <TestimonialCard
              key={testimonial.name}
              avatar={testimonial.avatar}
              name={testimonial.name}
              company={testimonial.company}
              companyLink={testimonial.companyLink}
              review={testimonial.reviewCondensed}
            />
          )
        })}
      </Slider>
    </Wrapper>
  )
}

export default TestimonialScroller
